(function () {
  function initCarousel(el) {
    const imgs = el.querySelectorAll('img');
    const dots = el.querySelectorAll('.mj-card__dots button');
    const prev = el.querySelector('.mj-card__nav--prev');
    const next = el.querySelector('.mj-card__nav--next');
    if (imgs.length < 2) return;
    let index = 0;

    function render() {
      imgs.forEach((img, i) => img.classList.toggle('is-active', i === index));
      dots.forEach((dot, i) => dot.classList.toggle('is-active', i === index));
    }

    dots.forEach((dot, i) =>
      dot.addEventListener('click', () => {
        index = i;
        render();
      })
    );
    if (prev)
      prev.addEventListener('click', () => {
        index = (index - 1 + imgs.length) % imgs.length;
        render();
      });
    if (next)
      next.addEventListener('click', () => {
        index = (index + 1) % imgs.length;
        render();
      });
  }

  function showToast(message) {
    let toast = document.querySelector('.mj-toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'mj-toast';
      toast.setAttribute('role', 'status');
      document.body.appendChild(toast);
    }
    toast.textContent = message;
    toast.classList.add('is-visible');
    clearTimeout(showToast.timer);
    showToast.timer = setTimeout(() => toast.classList.remove('is-visible'), 2600);
  }

  // Add to bag from a homepage card without leaving the page. Falls back to a
  // normal form post (→ cart page) when Dawn's cart drawer/notification is absent.
  function initCardForm(form) {
    form.addEventListener('submit', (event) => {
      const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      if (!cart || !window.routes) return;
      event.preventDefault();

      const button = form.querySelector('[type="submit"]');
      button.disabled = true;

      const formData = new FormData(form);
      formData.append(
        'sections',
        cart.getSectionsToRender().map((section) => section.id)
      );
      formData.append('sections_url', window.location.pathname);

      fetch(`${window.routes.cart_add_url}`, {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
        body: formData,
      })
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            showToast(response.description || response.message);
            return;
          }
          cart.classList.remove('is-empty');
          cart.renderContents(response);
        })
        .catch(() => form.submit())
        .finally(() => {
          button.disabled = false;
        });
    });
  }

  function init(root) {
    root.querySelectorAll('[data-mj-carousel]').forEach(initCarousel);
    root.querySelectorAll('[data-mj-card-form]').forEach(initCardForm);

    root.querySelectorAll('.mj-card__expand').forEach((button) => {
      button.addEventListener('click', () => {
        const isOpen = button.closest('.mj-card').classList.toggle('is-open');
        button.setAttribute('aria-expanded', String(isOpen));
      });
    });

    root.querySelectorAll('[data-mj-notify]').forEach((button) => {
      button.addEventListener('click', () => {
        const target = document.querySelector('.newsletter, .footer__newsletter');
        if (!target) return;
        target.scrollIntoView({ behavior: 'smooth', block: 'center' });
        const input = target.querySelector('input[type="email"]');
        if (input) input.focus({ preventScroll: true });
      });
    });
  }

  document.addEventListener('DOMContentLoaded', () => init(document));
  // Re-run when a section is re-rendered in the theme editor
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
